var _style, _line, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapeProductsUnifiedContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "777.6px",
    height: "877.3px",
    viewBox: "0 0 777.6 877.3",
    style: {
      enableBackground: "new 0 0 777.6 877.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#008187;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 269.1,
    y1: 0,
    x2: 269.1,
    y2: 877.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M470.5,646.7c-22.2-13.2-39.7-31-52.7-53.5c-13-22.5-19.5-47.1-19.5-73.8V400.7c0-26.8,6.5-51.3,19.5-73.8 c13-22.5,30.5-40.3,52.7-53.5c22.2-13.2,46.2-19.8,72.3-19.8c22.6,0,43.9,4.2,63.6,12.6c19.7,8.4,36.4,20.5,50.2,36.4 c2.2,2.6,3.4,5.7,3.4,9.5c0,3.7-1.6,7.4-4.5,11.2l-24.7,25.6c-2.9,2.9-5.9,4.5-9,4.5c-3.7,0-7.1-1.7-10.1-5 c-17.8-19.7-40.6-29.5-68.5-29.5c-13.8,0-26.5,3.7-38.1,11.2s-21.1,17.5-28.2,30.1c-7.1,12.6-10.5,26.2-10.5,40.6v118.8 c0,14.4,3.6,28.1,10.5,40.6c7.1,12.7,16.4,22.6,28.2,30.1c11.6,7.4,24.5,11.2,38.1,11.2c27.9,0,50.7-9.8,68.5-29.6 c2.9-3.4,6.2-5,9.5-5c3.4,0,6.5,1.6,9.5,4.5l24.5,25.6c3.4,3.4,5,7.1,5,11.2c0,1.7-0.5,3.3-1.1,5l117.4-44.2L665,186.4L1.3,66.4 l112.9,752l407.3-153.7C503.5,662.1,486.4,656.2,470.5,646.7z M377.7,508.1c0,30.1-6.4,57.2-19.2,81.4 c-12.9,24.2-30.5,42.9-52.9,56.6c-22.5,13.5-47.6,20.3-75.5,20.3c-28.2,0-53.6-6.8-76.1-20.6c-22.5-13.8-40.2-32.6-53-56.6 c-12.9-24-19.2-51-19.2-81.1V272.4c0-3.4,1.1-6.2,3.4-8.4c2.2-2.2,5-3.4,8.4-3.4h44.7c3.4,0,6.2,1.1,8.4,3.4c2.2,2.2,3.4,5,3.4,8.4 v238.6c0,26.8,7.3,48.4,22,64.7c14.7,16.4,34.1,24.5,58.3,24.5c23.7,0,42.9-8.2,57.7-24.5c14.7-16.3,22-37.8,22-64.7V272.4 c0-3.4,1.1-6.2,3.4-8.4c2.2-2.2,5-3.4,8.4-3.4h44.7c3.4,0,6.2,1.1,8.4,3.4c2.2,2.2,3.4,5,3.4,8.4v235.7H377.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeProductsUnifiedContacts);
export default __webpack_public_path__ + "static/media/shape-products-unified-contacts.e70cad7b70e9e797196c58f3d23743c1.svg";
export { ForwardRef as ReactComponent };